import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import Alert from '../../../../../../../components/global/Alert';
import { getErrorString } from '../../../../../../../util/normalize-errors';
import useOpenAlert from '../../../../../../../hooks/useOpenAlert';
import Button from '../../../../../../../components/global/Button';
import PinField from '../../../../../../../components/global/PinField';
import useEmailPinAuth from '../../../../../../../components/auth/hooks/useEmailPinAuth';

const propTypes = {
  values: PropTypes.shape({
    code: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};
const FreemiumEventCreateEmailPinVerificationStep = ({
  values,
  errors,
  handleChange,
}) => {
  const openAlert = useOpenAlert();
  const [loading, setLoading] = useState(false);
  const { onEmailAuthenticationRequest } = useEmailPinAuth();

  const onPinCodeResend = async () => {
    if (loading) {
      return;
    }

    try {
      setLoading(true);
      await onEmailAuthenticationRequest({
        emailAddress: values.account_email_address,
      });
    } catch (error) {
      openAlert({
        message: 'There was an error sending the PIN.',
        info: error?.request_id ?? getErrorString(error),
      });
    } finally {
      setLoading(false);
    }
  };

  const errorList = Object.values(errors);

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content size="lg">
        <div className="row">
          <div className="col-12">
            <div className="mx-auto freemium-phone-verification-pin-input">
              <PinField
                autofocus
                className="registration-pin-field"
                onComplete={value => {
                  handleChange({
                    target: {
                      name: 'account_code',
                      value,
                    },
                  });
                }}
                onChange={value => {
                  handleChange({
                    target: {
                      name: 'account_code',
                      value,
                    },
                  });
                }}
              />
              <Button
                btnStyle="link"
                onClick={() => onPinCodeResend()}
                disabled={loading}
              >
                {loading ? 'Resending...' : 'Resend code'}
              </Button>
            </div>
          </div>
        </div>
        {errorList.length > 0 && (
          <Alert type="danger" className="mt-1 text-normal">
            <ul className="mb-0">
              {errorList.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateEmailPinVerificationStep.propTypes = propTypes;

export default FreemiumEventCreateEmailPinVerificationStep;
